<template>
  <div class="article-container">
    <el-card>
      <el-form :model="articleForm" :rules="articleRules" ref="articleForm" label-width="80px">
        <el-form-item label="标题" prop="title">
          <el-input v-model="articleForm.title" placeholder="请输入文章标题" style="width: 80%"></el-input>
        </el-form-item>
        <el-form-item label="封面图" prop="coverImage">
          <el-upload
            class="avatar-uploader"
            :auto-upload="false"
            :on-change="handleImageChange"
            :show-file-list="false"
            :before-upload="beforeImageUpload"
          >
            <img v-if="articleForm.coverImageUrl" :src="articleForm.coverImageUrl" class="cover-image">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <div class="editor-container">
            <div ref="editor"></div>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitArticleForm('articleForm')">发布文章</el-button>
          <el-button @click="resetForm('articleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 文章列表 -->
    <el-card class="mt-20">
      <h3>已发布文章</h3>
      <el-table :data="articleList" style="width: 100%" class="mt-10">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="title" label="标题"></el-table-column>
        <el-table-column prop="createTime" label="发布时间"></el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button size="small" type="danger" @click="handleDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import Quill from 'quill'
import 'quill/dist/quill.snow.css'

export default {
  name: 'Article',
  data() {
    return {
      articleForm: {
        title: '',
        coverImage: null,  // 存储图片文件对象
        coverImageUrl: '', // 存储图片URL用于显示
        content: ''
      },
      articleRules: {
        title: [
          { required: true, message: '请输入文章标题', trigger: 'blur' }
        ],
        coverImage: [
          { required: true, message: '请上传封面图', trigger: 'change' }
        ],
        content: [
          { required: true, message: '请输入文章内容', trigger: 'change' }
        ]
      },
      articleList: [],
      editor: null
    }
  },
  mounted() {
    this.initEditor()
    this.loadArticleList()
  },
  methods: {
    initEditor() {
      this.editor = new Quill(this.$refs.editor, {
        theme: 'snow',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ 'header': 1 }, { 'header': 2 }],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            [{ 'script': 'sub'}, { 'script': 'super' }],
            [{ 'indent': '-1'}, { 'indent': '+1' }],
            [{ 'direction': 'rtl' }],
            [{ 'size': ['small', false, 'large', 'huge'] }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'font': [] }],
            [{ 'align': [] }],
            ['clean'],
            ['link', 'image', 'video']
          ]
        },
        placeholder: '请输入文章内容...'
      })
    },
    loadArticleList() {
      this.$http.get('/chuanmei/article')
        .then(response => {
          if (response.data.success) {
            this.articleList = response.data.data.map(item => {
              return {
                id: item.id.toString(),
                title: item.title,
                cover_image: 'http://quanyutui.ccdcamera.site' +item.cover_image,
                content: item.content,
                create_time: item.create_time,
                createTime: new Date(item.create_time).toLocaleString()
              }
            })
          } else {
            this.$message.error('获取文章列表失败')
          }
        })
        .catch(error => {
          console.error('获取文章列表失败:', error)
          this.$message.error('获取文章列表失败，请稍后重试')
        })
    },
    handleImageChange(file, fileList) {
      // 当用户选择图片后，保存文件对象并显示预览
      this.articleForm.coverImage = file.raw
      this.articleForm.coverImageUrl = URL.createObjectURL(file.raw)
    },
    beforeImageUpload(file) {
      const isImage = file.type.startsWith('image/')
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isImage) {
        this.$message.error('只能上传图片文件!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return isImage && isLt2M
    },
    submitArticleForm(formName) {
      this.articleForm.content = this.editor.root.innerHTML
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const formData = new FormData()
          formData.append('title', this.articleForm.title)
          formData.append('content', this.articleForm.content)
          
          // 如果有选择的图片文件，则添加到formData中
          if (this.articleForm.coverImage) {
            formData.append('coverImage', this.articleForm.coverImage)
          }

          this.$http.post('/chuanmei/article', formData)
            .then(response => {
              if (response.data.success) {
                this.$message.success('文章发布成功')
                this.loadArticleList()
                this.resetForm(formName)
              } else {
                this.$message.error(response.data.message || '发布失败')
              }
            })
            .catch(error => {
              console.error('发布文章失败:', error)
              this.$message.error('发布文章失败，请稍后重试')
            })
        } else {
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.editor.setText('')
      this.articleForm.coverImage = null
      this.articleForm.coverImageUrl = ''
    },
    handleDelete(id) {
      this.$confirm('确定要删除这篇文章吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.delete(`/chuanmei/article/${id}`)
          .then(response => {
            if (response.data.success) {
              this.$message.success('删除成功')
              this.loadArticleList()
            } else {
              this.$message.error(response.data.message || '删除失败')
            }
          })
          .catch(error => {
            console.error('删除文章失败:', error)
            this.$message.error('删除文章失败，请稍后重试')
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  }
}
</script>

<style scoped>
.article-container {
  max-width: 1200px;
  margin: 0 auto;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all 0.3s;
  width: 300px;
  height: 200px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 300px;
  height: 200px;
  line-height: 200px;
  text-align: center;
}

.cover-image {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.editor-container {
  height: 400px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
}

.mt-10 {
  margin-top: 10px;
}

.mt-20 {
  margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/Article.vue